
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EmailPreviewForm } from "../form/EmailPreviewForm";




type EmailPreviewDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  emailRowObject: any;

};

export const EmailPreviewDrawer: React.FC<EmailPreviewDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  emailRowObject
}) => {
  const { t } = useTranslation();

  //const referenceDrawer = useGenericDrawer()

  return (

    <Drawer
      title={t("emailhistory.drawer.emailpreview.title")}
      placement="right"
      width={950}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      <EmailPreviewForm
        emailRowObject={emailRowObject}
        onCloseDrawer={setDrawerOpen}
      />
    </Drawer>
  );
};
